export default {
    navigationBarTitleText: '客户顾问',
};
